import React, {Component} from 'react';
import {
  	BrowserRouter as Router,
  	Route,
	Switch,
} from 'react-router-dom'

import { Provider } from 'mobx-react';

//styles
import './App.scss';
import 'react-select/dist/react-select.css'
import 'react-virtualized/styles.css'
import 'react-virtualized-select/styles.css'

import AppStore from './store/store';

const store = window.store = new AppStore()

// components
import Header from '../Components/Layout/Header'
import Menu from '../Components/Layout/Menu'
import Footer from '../Components/Layout/Footer'

// containers
import Home from './Home/Home'
import About from './About/About'
import Tos from './About/Tos'
import Privacy from './About/Privacy'
import Disclaimer from './About/Disclaimer'
import TosSpecialists from './About/TosSpecialists'
import Features from './Features/Features'
import Pricing from './Pricing/Pricing'
import Contact from './Contact/Contact'
import Update from './Update/Update'
import UpdateView from './Update/View'
import UpdateComplete from './Update/Complete'
import Purchase from './Purchase/Purchase'
import Help from './Help/Help'
import PurchaseComplete from './Purchase/Complete'
import Listing from './Listing/Listing'
import ListingNew from './Listing/New'
import ListingComplete from './Listing/Complete'
import AlliedHealth from './AlliedHealth/AlliedHealth';

class App extends Component {
	render() {
		return (
			<Provider store={store}>
        		<Router>
					<div className="main">
						<Header>
							<Menu />	
						</Header>
						<Switch>
							<Route path="/" exact component={Home} />
							<Route path="/features" component={Features} />
							<Route path="/pricing" component={Pricing} />
							<Route path="/about" exact component={About} />
							<Route path="/about/tos" component={Tos} />
							<Route path="/about/specialist-tos" component={TosSpecialists} />
							<Route path="/about/privacy" component={Privacy} />
							<Route path="/about/disclaimer" component={Disclaimer} />
							<Route path="/help" exact component={Help} />
							<Route path="/contact" exact component={Contact} />
							<Route path="/update" exact component={Update} />
							<Route path="/allied-health" exact component={AlliedHealth} />
							<Route path="/update/view" exact component={UpdateView} />
							<Route path="/update/complete" exact component={UpdateComplete} />
							<Route path="/purchase" exact component={Purchase} />
							<Route path="/purchase/complete" exact component={PurchaseComplete} />
							<Route path="/login" exact  render={() => window.location="https://alpha.gpbook.com.au/"}/>
							<Route path="/listing" exact component={Listing} />
							<Route path="/listing/update" exact component={Update} />
							<Route path="/listing/new" component={ListingNew} />
							<Route path="/listing/complete" component={ListingComplete} />
						</Switch>
						<Footer />
					</div>
				</Router>
			</Provider>
		)
	}
}





export default App;



// WEBPACK FOOTER //
// ./src/Containers/App.js